import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalDirective } from '@shared/directives/modal.directive';

export interface IStatusChangeData {
  fromStatus: string;
  toStatus: string;
}

export interface IStatusChangeResult {
  confirmed: boolean;
  comment: string | null;
}

@Component({
    selector: 'app-modals-status-change-comment',
    templateUrl: './modals.status-change-comment.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalsStatusChangeCommentComponent
  extends ModalDirective<IStatusChangeResult>
  implements OnInit
{
  public title = String('MODALS.STATUS_CHANGE_COMMENT.TITLE');

  public fromStatus = String('');
  public toStatus = String('');

  public entry: FormGroup;

  constructor(private readonly _fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.createForm();

    this.openModal?.subscribe((data: IStatusChangeData) => {
      this.fromStatus = data.fromStatus;
      this.toStatus = data.toStatus;
    });
  }

  public onDismiss() {
    this.fromStatus = '';
    this.toStatus = '';
    this.entry.reset();
    this.afterSubmit({ confirmed: false, comment: null });
  }

  public onSubmit(): void {
    const comment = this.entry.value.comment?.trim() || null;
    const result: IStatusChangeResult = {
      confirmed: true,
      comment
    };
    this.resetModal(result);
  }

  protected createForm() {
    this.entry = this._fb.group({
      comment: ['']
    });
  }
}
